import { UntypedFormBuilder } from '@angular/forms';
import { FormGroupBase } from '../../ng-shared/components/form/form-group-base'
import { CampoFormulario} from '../../ng-shared/components/form/campo-formulario'

export class AcessoExternoFormGroup  extends FormGroupBase
{
    public static readonly codigoAcesso: CampoFormulario = new CampoFormulario({name: 'codigoAcesso', placeHolder: 'Código de Acesso', required: true, maxLength: 6});
    public static readonly cpf: CampoFormulario = new CampoFormulario({name: 'cpf', placeHolder: 'CPF', required: true, maxLength: 100});
    public static readonly email: CampoFormulario = new CampoFormulario({name: 'email', placeHolder: 'E-mail', required: true, maxLength: 100});
    public static myRecaptcha: CampoFormulario = new CampoFormulario({name: 'myRecaptcha', required: true});    
    
    public criarFormGroup(formBuilder: UntypedFormBuilder) {
        return formBuilder.group({
            [AcessoExternoFormGroup.codigoAcesso.name]: ['', AcessoExternoFormGroup.codigoAcesso.getValidators()],
            [AcessoExternoFormGroup.cpf.name]: ['', AcessoExternoFormGroup.cpf.getValidators()],
            [AcessoExternoFormGroup.email.name]: ['', AcessoExternoFormGroup.email.getValidators()],
            [AcessoExternoFormGroup.myRecaptcha.name] : ['',AcessoExternoFormGroup.myRecaptcha.getValidators()]
        });
    }

    constructor(formBuilder: UntypedFormBuilder)
    {
        super(formBuilder);
    }

    get campos() { return AcessoExternoFormGroup; }

}